import { useAnalytics } from "@/lib/analytics/analytics";
import { useI18n } from "@/lib/i18n/i18n_provider";
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";

interface ExpiredPaymentWarningProps {
  orderId?: string;
  paymentType?: string;
}

export const ExpiredPaymentWarning = ({
  orderId,
  paymentType,
}: ExpiredPaymentWarningProps) => {
  const { fbt } = useI18n();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.event(
      "Payment Timeout",
      {
        "Payment Type": paymentType,
        "Order ID": orderId,
      },
      { onlyProviders: ["mixpanel", "customerio"] }
    );
  }, [analytics, orderId, paymentType]);

  return (
    <div className="border p-3 mb-3">
      <div className="d-flex align-items-center">
        <div>
          <strong>{fbt("Checkout session expired")}</strong>
          <p className="mb-0 text-muted">
            {fbt(
              "Your checkout session has expired. Please refresh your page."
            )}
          </p>
        </div>
      </div>
      <div>
        <Button
          variant="outline-primary"
          size="sm"
          className="mt-2"
          onClick={() => window.location.reload()}
        >
          {fbt("Refresh Page")}
        </Button>
      </div>
    </div>
  );
};
